module.exports = __webpack_public_path__ + "static/img/jtgk_lhyw_bg.d19e8ed.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/jtgk_lhyw_bg.png
// module id = /j6G
// module chunks = 0